import React from 'react';

import Icon from '../../Shared/Icon/Icon';

export default class TutorialSearch extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sort: 'latest',
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onFilterClick = this.onFilterClick.bind(this);
  }

  onSubmit(e) {
    e.preventDefault();

    return this.props.onFormSubmit(this.searchValue.value);
  }

  onFilterClick(e) {
    const sort = e.currentTarget.attributes.getNamedItem('value').value;

    this.setState({
      sort,
    });

    return this.props.onSortFilterClick(sort);
  }

  render() {
    return (
      <div className="tutorials-search__section">
        <div className="tutorials-search">
          <form onSubmit={this.onSubmit}>
            <button className="tutorials-search__button" type="submit">
              <Icon type="search" size="lg" />
            </button>
            <input
              name="keywords"
              autoComplete="off"
              className="tutorials-search__field"
              ref={(input) => {
                this.searchValue = input;
              }}
              placeholder="search tutorials"
              type="search"
            />
          </form>
        </div>
        <div className="tutorials-sorting__section">
          <ul>
            Sort by:
            <li>
              <button onClick={this.onFilterClick} className="button--link" value="latest">
                latest
              </button>
              /
            </li>
            <li>
              <button onClick={this.onFilterClick} className="button--link" value="best">
                best
              </button>
            </li>
          </ul>
          <button className="button mobile-filters-button" onClick={this.props.onMobileFiltersClick}>
            Filters
          </button>
        </div>
      </div>
    );
  }
}
